<template>
	<v-card class="pa-4 mb-2" rounded>
		<v-card-text v-if="!contribuyente && contribuyente !== null">
			<v-alert
				border="left"
				colored-border
				color="siiNaranjo"
				elevation="2"
				type="warning"
			>
				Ingrese un RUT a consultar
			</v-alert>
		</v-card-text>
		<v-card-actions>
			<v-form v-model="config.validaciones.valid" @submit.prevent="getDatos" style="width: 100%;">
				<v-text-field 
					flat
					solo
					background-color="grey lighten-2"
					placeholder="Rut Contribuyente"
					rounded
					class=""
					hide-details
					full-width
					v-model="contribuyenteConsultar"
					v-rut-mask
					:rules="config.validaciones.usuarioValido"
				>
					<template v-slot:prepend-inner>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									fab
									small
									v-on="on"
									@click="userActualEvt"
								>
									<v-icon>
										assignment_ind
									</v-icon>
								</v-btn>
							</template>
							<span>Utilizar contribuyente actual: {{rutContribuyente}}</span>
						</v-tooltip>
					</template>
					<template v-slot:append>
						<v-btn type="submit" color="primary" rounded :disabled="!config.validaciones.valid">
							Buscar
							<v-icon right>
								send
							</v-icon>
						</v-btn>
					</template>
				</v-text-field>
			</v-form>
		</v-card-actions>
		<template v-if="!!contribuyente">
			<v-card-title>
				<v-btn fab small @click="getDatos()">
					<v-icon>refresh</v-icon>
				</v-btn>
				{{titleLabel}}
				<v-spacer/>
				
				<descargador-caf
					:contribuyente="contribuyente" @alert="emitirAlerta"
				/>
			</v-card-title>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="siiNaranjo" dark @click="actualizarContribuyente">
					<v-icon left>
						update
					</v-icon>
					Actualizar Contribuyente
				</v-btn>
			</v-card-actions>
			<v-card-text>
				<v-tabs
					v-model="config.tab"
					align-with-title
					grow
				>
					<v-tab
						v-for="item in config.tabs"
						:key="item"
					>
						{{ item }}
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="config.tab">
					<v-expand-transition>
						<v-tab-item>
							<informacion-contribuyente
								v-if="config.activo.contribuyente"
								:contribuyente="contribuyente"
							/>
						</v-tab-item>
					</v-expand-transition>
					<v-expand-transition>
						<v-tab-item>
							<sucursal
								v-if="config.activo.sucursal"
								:sucursales="sucursales"
							/>
						</v-tab-item>
					</v-expand-transition>
					<v-expand-transition>
						<v-tab-item>
								<usuario
									v-if="config.activo.usuario"
									:usuarios="usuarios"
								/>
						</v-tab-item>
					</v-expand-transition>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="siiNaranjo" dark @click="actualizarContribuyente">
					Actualizar Contribuyente
					<v-icon right>
						update
					</v-icon>
				</v-btn>
			</v-card-actions>
		</template>
		<v-card-text v-else-if="contribuyente === null">
			<v-alert
				border="left"
				colored-border
				color="siiNaranjo"
				elevation="2"
				type="error"
			>
				No hemos encontrado información del contribuyente {{contribuyenteConsultar}}
			</v-alert>
		</v-card-text>
		<v-overlay :value="config.loading">
			<v-progress-circular
				indeterminate
				size="64"
			></v-progress-circular>

		</v-overlay>
		<v-dialog
			v-model="isUpdating"
			hide-overlay
			persistent
			width="300"
		>
			<v-card
				color="primary"
				dark
			>
				<v-card-title>
					Actualizando...
				</v-card-title>
				<v-card-text>
					<v-fade-transition>
						<v-list color="transparent">
							<v-list-item >
								<v-list-item-content>
									Actualizando Contribuyente
								</v-list-item-content>
								<v-list-item-avatar>
									<v-scroll-x-transition 
										v-if="!config.actualizar.contribuyente"
										absolute
									>
										<v-icon
											color="success"
										>
											check
										</v-icon>
									</v-scroll-x-transition>
									<v-icon
										v-else
									>
										clear
									</v-icon>
								</v-list-item-avatar>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									Actualizando Usuarios
								</v-list-item-content>
								<v-list-item-avatar>
									<v-scroll-x-transition absolute>
										<v-icon color="success" v-if="!config.actualizar.usuarios">
											check
										</v-icon>
										<v-icon v-else>
											clear
										</v-icon>
									</v-scroll-x-transition>
								</v-list-item-avatar>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									Actualizando Sucursales
								</v-list-item-content>
								<v-list-item-avatar>
									<v-scroll-x-transition absolute>
										<v-icon color="success" v-if="!config.actualizar.sucursales">
											check
										</v-icon>
										<v-icon v-else>
											clear
										</v-icon>
									</v-scroll-x-transition>
								</v-list-item-avatar>
							</v-list-item>
						</v-list>
					</v-fade-transition>
					<v-card-actions>
						<v-progress-linear
							indeterminate
							color="white"
							class="mb-0"
						></v-progress-linear>
					</v-card-actions>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-snackbar
      v-model="alert.display"
			:color="alert.type"
    >
      {{ alert.msg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="alert.display = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
	</v-card>
</template>

<script>

import { rutValidate } from 'rut-helpers';

import Sucursal from './Sucursal';
import Usuario from './Usuario';
import InformacionContribuyente from './InformacionContribuyente';

import { API } from 'aws-amplify';
import { mapState } from 'vuex';
import {tiposDte, diccionarioDte} from '@/vessi.utils.js';

import ApiManager from '@/library/utils/ApiManager';

const apiSucursal = new ApiManager('eBoletaActualizador');

import * as InfoContribuyente from '@/library/utils/info-contribuyente';

import DescargadorCaf from './DescargadorCaf';

export default {
	name: 'AdminContribuyente',
	components:{
		InformacionContribuyente,
		Sucursal,
		Usuario
		,DescargadorCaf
	},
	data () {
		return {
			config:{
				loading: false,
				activo:{
					contribuyente: true,
					sucursal: true,
					usuario: true,
				},
				tabs:[
					'contribuyente',
					'sucursal',
					'usuario'
				],
				actualizar:{
					contribuyente: false,
					usuarios: false,
					sucursales: false
				},
				tab: 0,
				validaciones:{
					usuarioValido: [
						v=>!!v || 'Introduzca un usuario',
						v=>rutValidate(v) || 'Ingrese un rut válido'
					],
					valid: false
				},
			},
			alert:{
				display: false,
				msg: '',
				type: ''
			}
			,contribuyente: undefined,
			sucursales:[],
			usuarios:[],
			contribuyenteConsultar: undefined,
		}
	},
	computed:{
		titleLabel(){

			let rut = this.contribuyente.rut;
			let nombre = !!this.contribuyente? !!this.contribuyente.nombres? `${this.contribuyente.nombres} ${this.contribuyente.apellido_paterno} ${this.contribuyente.apellido_materno}`: '': '';
			
			let razon_social = !!this.contribuyente? this.contribuyente.razon_social|| nombre: undefined;

			if( !rut || !razon_social )
				return '';
			
			return `${rut} - ${razon_social}`;
		},
		rutContribuyente(){

			let vm = this;
			let contribuyente = vm.$store.getters['empresas/rut'];
			contribuyente = vm.rutFormatter(contribuyente);
			return contribuyente;
		},
		isUpdating(){
			return this.config.actualizar.contribuyente || this.config.actualizar.usuarios || this.config.actualizar.sucursales;
		}
	},
	methods:{
		emitirAlerta: function(info){
			this.alert.msg = info.mensaje;
			this.alert.type = info.tipo;
			this.alert.display = true;
		},
		actualizarContribuyente: async function(evt){

			let vm = this;
			let contribuyente = vm.contribuyente;
			if(!contribuyente) {
				vm.showMsg('error', 'No hay contribuyente cargado para actualizar');
				return;
			}
			let rutDv = `${vm.contribuyente.rut}-${vm.contribuyente.dv}`;

			const displayError = function(error, defMsg, errorDic=null){

				let {response:{data={}}={}} = error;

				if( typeof data === 'string' ){
					vm.showMsg('error', data);
					return;
				}
				let {code=null} = data;

				let msg = defMsg || 'Ha ocurrido un error inesperado.';

				if( code == null ){
					// NOT IMPLEMENTED YET
				}else if( code == 'BadRequestException' ){

					msg = `Ha ocurrido un error al consultar los últimos datos.`;
				}else{
					// NOT IMPLEMENTED YET
				}

				vm.showMsg('error', msg);
			}

			// actualizar contribuyente
			try{

				vm.config.actualizar.contribuyente = true;
				vm.config.actualizar.sucursales = true;
				vm.config.actualizar.usuarios = true;

				let params = {
					headers:{},
					body:{
						user: vm.$store.getters['usuario/usuario']
					}
				};

				let path =`/update-contribuyente-sii/${rutDv}`;

				await apiSucursal.post(path, params);

			}catch(err){
				
				vm.config.actualizar.sucursales = false;
				vm.config.actualizar.usuarios = false;
				vm.config.actualizar.contribuyente = false;
				
				displayError(err);

				return;
			}finally{
				vm.config.actualizar.contribuyente = false;
			}

			// actualizar sucursales y usuarios
			try{

				let params = {
					headers:{},
					body:{
						user: vm.$store.getters['usuario/usuario']
					}
				};

				let sucursalFunction = async function(){

					try{

						vm.config.actualizar.sucursales = true;

						let sucursalPath =`/update-sucursales-sii/${rutDv}`;
						await apiSucursal.post(sucursalPath, params);

					}catch(err){

						displayError(err);
					}finally{

						vm.config.actualizar.sucursales = false;
					}
				};

				let usuarioFunction = async function(){

					try{

						vm.config.actualizar.usuarios = true;

						let userPath = `/update-usuarios-sii/${rutDv}`;
						await apiSucursal.post(userPath, params);
					}catch(err){
						
						displayError(err);
					}finally{

						vm.config.actualizar.usuarios = false;
					}
				};

				let asyncCalls = [
					sucursalFunction(),
					usuarioFunction(),
				];

				await Promise.all( asyncCalls );

			}catch(err){
				
				throw err;
			}
		},
		getDatos: async function(){

			let vm = this;

			if( !vm.contribuyenteConsultar )
				return;

			vm.config.loading = true;

			try{

				let contribuyenteSDV = vm.contribuyenteConsultar.split('-')[0];
				let path = `/${contribuyenteSDV}/info`;
				vm.limpiarDatos();

				let response = await apiSucursal.getCall(path);

				vm.sucursales = response.sucursales;
				vm.contribuyente = !!response.contribuyente? vm.formatVars(response.contribuyente): null;
				vm.usuarios = response.usuarios;

			}catch(err){

				vm.config.loading = false;
				throw err;
			}finally{
				vm.config.loading = false;
			}
		},
		limpiarDatos: function(){
			this.sucursales = [];
			this.contribuyente = {
				rut: undefined,
				dv: undefined,
				razon_social: undefined,
				giro: undefined,
				actividad_economica: undefined,
				telefono: undefined,
				email: undefined,
				direccion: undefined,
				comuna: undefined,
				fecha_resolucion: undefined,
				numero_resolucion: undefined,
				nombres: undefined,
				apellido_paterno: undefined,
				apellido_materno: undefined,
				autoriza: undefined,
				fecha_autorizacion: undefined,
				fecha_desautorizacion: undefined,
			};
		},
		rutFormatter: function(rut) {
			if (!rut) return '';
			let str = rut.replace(/\.|-/g, '');
			return `${str.slice(0,-1)}-${str.slice(-1)}`;
		},
		formatVars: function(contribuyente){
			contribuyente.fecha_resolucion = this.fechaFormatter(contribuyente.fecha_resolucion);
			contribuyente.fecha_autorizacion = this.fechaFormatter(contribuyente.fecha_autorizacion);
			contribuyente.fecha_desautorizacion = this.fechaFormatter(contribuyente.fecha_desautorizacion);

			return contribuyente;
		},
		fechaFormatter: function(timestamp){
			if( !timestamp )	return timestamp;

			let date = new Date(timestamp);

			let formatZeroes = function(n){
				return n<10? '0'+n: n;
			}

			let yyyy = date.getUTCFullYear();
			let mm = formatZeroes(date.getUTCMonth());
			let dd = formatZeroes(date.getUTCDate());
			let hh = formatZeroes(date.getUTCHours());
			let min = formatZeroes(date.getUTCMinutes());
			let ss = formatZeroes(date.getUTCSeconds());

			return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
		},
		userActualEvt: function(){
			this.contribuyenteConsultar = this.rutContribuyente;
			this.getDatos();
		},
		showMsg(type, msg){
			this.alert.display = true;
			this.alert.msg = msg;
			this.alert.type = type;
		}
	},
	mounted(){
		this.getDatos();
	}
}
</script>

<style lang="css" scoped>
</style>
